<template>
  <router-view />
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { usePermissionStore } from '@/store/modules/permission'
import { useWebSocket } from '@/composables/useWebSocket'

const userStore = useUserStore()
const permissionStore = usePermissionStore()
const { connect } = useWebSocket()

// 页面刷新时恢复状态
onMounted(async () => {
  if (userStore.token) {
    // 恢复用户信息
    if (!userStore.userInfo?.email) {
      const saved = localStorage.getItem('userInfo')
      if (saved) {
        try {
          userStore.userInfo = JSON.parse(saved)
          userStore.roles = JSON.parse(localStorage.getItem('roles') || '[]')
          userStore.permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
        } catch (e) {}
      }
    }

    // 加载菜单
    if (!permissionStore.routesLoaded) {
      await permissionStore.fetchMenus()
      permissionStore.setPermissions(userStore.permissions)
      permissionStore.routesLoaded = true
    }

    // 连接WebSocket实时通知
    connect()
  }
})

// token变化时自动连接/断开
watch(() => userStore.token, (newToken) => {
  if (newToken) connect()
})
</script>

<style>
/* ===== 全局滚动条美化 ===== */
/* 适用于 Chrome / Safari / Edge (WebKit) */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
  transition: background 0.2s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* ===== Firefox 支持 ===== */
* {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;
}
</style>